<template>
  <vue-modal id="passBuyModal"
             classes="vue-modal-container"
             height="auto"
             name="pass-buy-modal"
             scrollable
             style="text-align: center;"
             width="80%"
             @closed="modalClosed"
             @opened="modalOpened"
             @before-open="beforeModalOpen">
    <div class="header">
      <h3>Bérlet vásárlása</h3>
      <button class="close-modal"
              @click="$modal.hide('pass-buy-modal')">
        <i class="close icon"/>
      </button>
      <!--      <div>{{ $store.state.availableItems.filter(item => item.itemType === 'pass') }}</div>-->
      <div v-if="step === 'SELECT_CLIENT'">
        <button v-for="client in availableClients"
                class="ui button"
                @click="selectClient(client.domain)">
          {{ client.name }}
        </button>
      </div>
      <div v-else-if="step === 'SELECT_PASS'">
        <div v-for="pass in availablePassesForSelectedClient"
             class="row align-middle bordered width-large-75">
          <div class="small-6 large-6 font-bold columns">
            {{ pass.name }} {{ pass.price }}
          </div>
          <div class="small-6 large-3 columns">
            {{ getFormattedCurrency(pass.price) }}
          </div>
          <div class="small-12 large-3 columns">
            <button class="ui button"
                    style="margin: 4px 0;"
                    @click="selectPass(pass.id)">
              Vásárlás
            </button>
          </div>
        </div>
      </div>
      <div v-else-if="step === 'SUCCESS'">
        SUCCESS
      </div>
    </div>
    <div class="content">
      <button v-if="step === 'SELECT_PASS'"
              :class="''"
              class="digital-confirm-btn secondary-type"
              @click="step = 'SELECT_CLIENT'">
        Vissza
      </button>
      <div class="margin-top-1"><i>Bérletet csak akkor vásárolhatsz, ha már foglaltál pályát az adott partnerhez.</i>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'
// eslint-disable-next-line
// eslint-disable-next-line
import {getFormattedCurrency} from '@/utils';

export default {
  components: {},
  data () {
    return {
      selectedClient: null,
      step: 'SELECT_CLIENT', // SELECT_CLIENT, SELECT_PASS, SUCCESS
    }
  },
  methods: {
    beforeModalOpen (event) {
      if (event?.params?.client) {
        if (this.availableClients.find(client => client.domain === event.params.client)) {
          this.selectClient(event.params.client)
        }
      }
    },
    getFormattedCurrency,
    modalOpened () {
    },
    modalClosed () {
      this.selectedClient = null
      this.step = 'SELECT_CLIENT'
    },
    selectClient (client) {
      this.selectedClient = client
      this.step = 'SELECT_PASS'
    },
    selectPass (passID) {
      this.$store.dispatch(
        'startPassBuyWithCard',
        {
          boughtItems: [{ id: passID, quantity: 1 }],
          client: this.selectedClient,
        })
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.passBuyModal,
    }),
    availableClients () {
      const availableClients = []
      const clientsInAvailableItems = [...new Set(this.$store.state.availableItems.map(item => item.client))]
      for (const client of this.$store.state.clients) {
        if (clientsInAvailableItems.includes(client.domain)) availableClients.push(client)
      }
      return availableClients
    },
    availablePassesForSelectedClient () {
      return this.$store.state.availableItems.filter(item => item.itemType === 'pass' && item.client === this.selectedClient)
    },
  },
}
</script>

<style scoped>
.width-large-75 {
  @media (min-width: 767px) {
    width: 75%;
  }
}

.digital-input {
  width: 50%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.digital-confirm-btn {
  width: 50%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  //border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: #f2711c;
  color: white;
}

.digital-confirm-btn:hover {
  background: #f2711ce0;
}

.digital-confirm-btn.secondary-type {
  background: rgb(28, 89, 242);
}

.digital-confirm-btn.secondary-type:hover {
  background: rgba(28, 89, 242, 0.88);
}

.digital-confirm-btn:disabled {
  opacity: .7;
  background: #f2711c;
  color: white;
  cursor: not-allowed;
}
</style>
